import { render } from "./Index.vue?vue&type=template&id=456176ee"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Reports/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "456176ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('456176ee', __exports__)) {
    console.log('reload')
    api.reload('456176ee', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=456176ee", () => {
    console.log('re-render')
    api.rerender('456176ee', render)
  })

}


export default __exports__